import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

const studentNav = [
  { to: "/prehled", label: "Přehled" },
  { to: "/testy", label: "Testy" },
  { to: "/pokrok", label: "Můj pokrok" },
];
const parentNav = [{ to: "/rodic", label: "Rodičovský přehled" }];
const adminNav = [
  { to: "/testy", label: "Vyzkoušet testy" },{ to: "/admin", label: "Správa testů" }];

export default function AppShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return <Outlet />;

  const nav =
    user.role === "student" ? studentNav :
    user.role === "parent" ? parentNav :
    user.role === "admin" ? adminNav : [];

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-parchment">
      <header className="border-b border-stone bg-parchment/80 backdrop-blur sticky top-0 z-30">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-baseline gap-2" data-testid="brand-link">
            <span className="font-serif text-2xl text-navy tracking-tight">Discendo</span>
            <span className="caption hidden sm:inline">Cermat příprava</span>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace("/","")}`}
                className={({ isActive }) =>
                  `text-sm transition-colors ${
                    isActive ? "text-navy font-medium" : "text-slate hover:text-ink"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-sm text-slate">
              {user.first_name}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              data-testid="logout-btn"
              className="text-slate hover:text-burgundy hover:bg-transparent"
            >
              Odhlásit
            </Button>
          </div>
        </div>
        <div className="md:hidden border-t border-stone">
          <div className="max-w-[1280px] mx-auto px-6 flex gap-5 overflow-x-auto py-3">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `text-sm whitespace-nowrap ${isActive ? "text-navy font-medium" : "text-slate"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-stone py-8">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-sm text-slate">© {new Date().getFullYear()} Discendo — příprava na přijímací zkoušky.</p>
          <p className="caption">Zkušební provoz</p>
        </div>
      </footer>
    </div>
  );
}
